import { render } from "./VideoPlayer.vue?vue&type=template&id=a9b47032"
const script = {}

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__